var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('IndicatorsSettings',{ref:"settings",attrs:{"themes":_vm.themeList,"url-prefix":"/server/config/schemes/indicators/","scheme-id":_vm.schemeId,"config":""},on:{"update":_vm.updateThemes}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }